<template>
  <div>
    <div class="page-filter-box">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
          <el-select v-model="params.status" placeholder="请选择" size="small" clearable>
            <el-option label="仅看展示的" :value="1"></el-option>
            <el-option label="仅看隐藏的" :value="0"></el-option>
			<el-option label="不限制展示状态" value=""></el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
          <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
          <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
        </el-col>
      </el-row>
    </div>
	<div class="page-btns-box">
	    <el-button
	        v-if="$utils.have('/lpa/importData')"
	        type="primary"
	        icon="el-icon-plus"
	        @click="add"
	        size="small"
	        >新增</el-button
	    >
	    <el-button
	        v-if="$utils.have('/lpa/updateRand')"
	        type="primary"
	        icon="el-icon-sort"	        
	        size="small"
			@click="RefreshRank"
	        >更新榜单</el-button
	    >
		<el-button
		    v-if="$utils.have('/lpa/updateRand')"
		    type="primary"
		    icon="el-icon-s-tools"	        
		    size="small"
			@click="setting"
		    >榜单配置</el-button
		>
		<el-button
		    v-if="$utils.have('/lpa/statistics')"
		    type="primary"
		    icon="el-icon-s-data"	        
		    size="small"
			@click="voteData"
		    >投票数据</el-button
		>
	</div>
    <el-tabs type="border-card" v-model="activeMain" @tab-click="handleMainTabClick">
      <!-- 最佳现场 (有二级 tabs) -->
      <el-tab-pane label="最佳现场" name="2">
        <el-tabs v-model="activeSubMap['2']" @tab-click="handleSubTabClick">
          <el-tab-pane 
            v-for="sub in subCategories" 
            :key="sub.value"
            :label="sub.label" 
            :name="sub.value"
          >
            <LpaTable 
              v-if="activeMain === '2' && activeSubMap['2'] === sub.value"
              :ref="getTableRef('2', sub.value)"
              :type="2"
              :styleId="parseInt(sub.value)"
              :filterStatus="params.status"
              :key="`2_${sub.value}`"
            />
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>

      <!-- 最具潜力 (有二级 tabs) -->
      <el-tab-pane label="最具潜力" name="3">
        <LpaTable
          v-if="activeMain === '3'"
          ref="table_3"
          :type="3"
          :styleId="null"
          :filterStatus="params.status"
          :noSub="true"
        />
      </el-tab-pane>

      <!-- 最佳厂牌 (无二级，直接展示表格) -->
      <el-tab-pane label="最佳厂牌" name="5">
        <LpaTable 
          v-if="activeMain === '5'"
          ref="table_5"
          :type="5"
          :styleId="null"
          :filterStatus="params.status"
          :noSub="true"
        />
      </el-tab-pane>

      <!-- 最佳场地 (无二级，直接展示表格) -->
      <el-tab-pane label="最佳场地" name="4">
        <LpaTable 
          v-if="activeMain === '4'"
          ref="table_4"
          :type="4"
          :styleId="null"
          :filterStatus="params.status"
          :noSub="true"
        />
      </el-tab-pane>

      <!-- 最佳体验音乐节 (无二级，直接展示表格)   const TYPE_OPTIONS = {
		'2': '最佳现场', '3': '最具潜力', '4': '最佳场地', '5': '最佳厂牌',
		'6': '最佳体验音乐节', '7': '最具人气', '8': '年度音乐人', '9': '特殊贡献'
	};-->
      <el-tab-pane label="最佳体验音乐节" name="6">
        <LpaTable 
          v-if="activeMain === '6'"
          ref="table_6"
          :type="6"
          :styleId="null"
          :filterStatus="params.status"
          :noSub="true"
        />
      </el-tab-pane>  
	  
	  <el-tab-pane label="最具人气" name="7">
	    <el-tabs v-model="activeSubMap['7']" @tab-click="handleSubTabClick">
	      <el-tab-pane 
	        v-for="sub in subCategories" 
	        :key="sub.value"
	        :label="sub.label" 
	        :name="sub.value"
	      >
	        <LpaTable 
	          v-if="activeMain === '7' && activeSubMap['7'] === sub.value"
	          :ref="getTableRef('7', sub.value)"
	          :type="7"
	          :styleId="parseInt(sub.value)"
	          :filterStatus="params.status"
	          :key="`7_${sub.value}`"
	        />
	      </el-tab-pane>
	    </el-tabs>
	  </el-tab-pane>  
	  
	  <el-tab-pane label="年度音乐人" name="8">
	    <LpaTable 
	      v-if="activeMain === '8'"
	      ref="table_8"
	      :type="8"
	      :styleId="null"
	      :filterStatus="params.status"
	      :noSub="true"
	    />
	  </el-tab-pane>
	  <el-tab-pane label="特殊贡献" name="9">
	    <LpaTable 
	      v-if="activeMain === '9'"
	      ref="table_9"
	      :type="9"
	      :styleId="null"
	      :filterStatus="params.status"
	      :noSub="true"
	    />
	  </el-tab-pane>
    </el-tabs>
	<add ref="Add" @update="refreshAll()"></add>
  </div>
</template>

<script>
import LpaTable from './components/LpaTable.vue'
import Add from  './components/add.vue'
const defaultQuery = {   
  status: 1
}

export default {
  components: { LpaTable , Add },
  data() {
    return {
      params: { ...defaultQuery },
      activeMain: '2',
      
      // 只有最佳现场(2)和最具潜力(3)需要记录选中的小类
      activeSubMap: {
        '2': '1',
        '7': '1'
      },
      
      // 小类配置（只有最佳现场和最具潜力使用）
      subCategories: [
        { label: '摇滚', value: '1' },
        { label: 'hiphop', value: '2' },
        { label: '民谣', value: '3' },
        { label: '流行', value: '4' },
        { label: '另类', value: '5' },
        { label: '海外', value: '6' }
      ]
    }
  },
  
  methods: {
    getTableRef(mainValue, subValue) {
      return subValue ? `table_${mainValue}_${subValue}` : `table_${mainValue}`
    },
    
    getCurrentTable() {
      const main = this.activeMain
      // 最佳现场(2)
      if (main === '2' || main === '7') {
        const sub = this.activeSubMap[main]
        const refName = `table_${main}_${sub}`
        return this.$refs[refName]
      } else {
        const refName = `table_${main}`
        return this.$refs[refName]
      }
    },
    
    search() {
      const currentTable = this.getCurrentTable()
      if (currentTable && currentTable.fetchData) {
        currentTable.fetchData()
      }
    },
    
    reset() {
      this.params = { ...defaultQuery }
      this.search()
    },
	refreshAll() {
	  // 强制刷新所有已渲染的表格
	  const allRefs = this.$refs
	  Object.keys(allRefs).forEach(key => {
	    const ref = allRefs[key]
	    if (ref && ref.fetchData) {
	      ref.fetchData()
	    }
	    // 处理 ref 是数组的情况（v-for 生成的多个）
	    if (Array.isArray(ref)) {
	      ref.forEach(item => {
	        if (item && item.fetchData) {
	          item.fetchData()
	        }
	      })
	    }
	  })
	},
    add() {
        this.$refs.Add.show();
    },
	setting(){
		this.$router.push({path:'/operation/lpa/setting'})
	},
    voteData(){
		this.$router.push({path:'/operation/lpa/votedata'})
	},
	handleAddSuccess() {	   
	    this.refreshAll()
	  },
    handleMainTabClick() {
      // 切换大类时，重置小类选中状态（如果是2或7）
      if (this.activeMain === '2' || this.activeMain === '7' ) {
        if (!this.activeSubMap[this.activeMain]) {
          this.$set(this.activeSubMap, this.activeMain, '1')
        }
      }
    },
    RefreshRank(){		
		    this.$confirm('确认更新并展示当前所有榜单排名？', '提示', {
		        type: 'warning',
		        center: true,
		        closeOnClickModal: false
		    }).then(() => {
		        this.$request({
		            url: "/lpa/updateRand",
		            params: { year: 2026 },
		            method: "post",
		        })
		            .then((res) => {
		                const { state, msg } = res.data;
		                if (state == 1) {
		                    this.$message.success('更新成功！');
		                    this.search()
		                } else {
		                    this.$message.error(msg || "操作失败,请重试");
		                }
		            })
		            .catch(() => {
		                this.$message.error("操作失败,请重试");
		            })
		    }).catch(() => {})
		
	},
    handleSubTabClick() {
      // 切换小类时不需要额外操作
    }
  }
}
</script>